<div *ngIf="polygonSymbol symbol-editor" class="draw-options">

    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Apply color to entire layer:</label>
        <input type="checkbox" class="pull-right checkbox" [(ngModel)]="applyColorToEntireLayer"
            (change)="applyColorToEntireLayerCheckboxChange()">
    </div>

    <div class="clearfix legendWideControlGroup" *ngIf="applyColorToEntireLayer">
        <label class="pull-left" (click)="layerColorPicker.showColorPicker = !layerColorPicker.showColorPicker">Layer Color:</label>
        <mc-color-picker-ng #layerColorPicker
            class="color-swatch right"  
            [color]="symbolColor" 
            (colorChange)="updateColorFromPicker($event)">
        </mc-color-picker-ng>
        <a class="right cancel-button" *ngIf="!esriLayer || !(esriLayer.mapcoreProps.color === null || esriLayer.mapcoreProps.color === originalColor)" (click)="cancelColorChange('layerColor')">Cancel</a>
    </div>

    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Fill Type:</label>
        <select class="pull-right" [(ngModel)]="fillStyle">
            <option [value]="style.value" *ngFor="let style of fillStyleOptions">{{ style.name }}</option>
        </select>
    </div>

    <div class="clearfix legendWideControlGroup" *ngIf="fillStyle !== 'none' && !applyColorToEntireLayer">
        <label class="pull-left" (click)="colorPicker.showColorPicker = !colorPicker.showColorPicker">Fill Color:</label>
        <mc-color-picker-ng #colorPicker 
            class="color-swatch right"
            [color]="symbolColor" 
            (colorChange)="updateColorFromPicker($event)">
        </mc-color-picker-ng>
        <a class="right cancel-button" *ngIf="symbolColor !== originalColor" (click)="cancelColorChange()">Cancel</a>
    </div>

    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Outline Type:</label>
        <select class="pull-right" [(ngModel)]="outlineStyle">
            <option [value]="style.value" *ngFor="let style of lineStyleOptions">{{ style.name }}</option>
        </select>
    </div>

    <div class="clearfix legendWideControlGroup" *ngIf="!applyColorToEntireLayer">
        <label class="pull-left" (click)="outlineColorPicker.showColorPicker = !outlineColorPicker.showColorPicker">Outline Color:</label>
        <mc-color-picker-ng #outlineColorPicker 
            class="color-swatch right"
            [color]="outlineColor" 
            (colorChange)="updateColorFromPicker($event, 'outlineColor')">
        </mc-color-picker-ng>
        <a class="right cancel-button" *ngIf="outlineColor !== originalOutlineColor" (click)="cancelColorChange('outlineColor')">Cancel</a>
    </div>

    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Outline Width:</label>
        <input class="pull-right" type="text" [(ngModel)]="outlineWidth" style="width:100px" />
    </div>
</div>
